export default __webpack_public_path__ + "static/media/tete48.ac510521.png";